<template>
  <div>

    <vs-row class="mb-3" >
      <vs-button disabled color="dark" type="flat"><h5>Manage Work / </h5></vs-button>
     <vs-button type="flat" to="/workorder"> <h5>Work Management</h5></vs-button>
     <vs-button disabled  color="dark" type="flat"><b><h5>/ Work Template</h5></b> </vs-button>
    </vs-row>
   
    
    <!-- <b-breadcrumb  style="background-color: #ffffff; padding-left: 0px; ">
      <b-breadcrumb-item active><h5>Manage Work</h5></b-breadcrumb-item>
      <b-breadcrumb-item  to="/workorder"
        ><h5 id="wb">Work Management</h5></b-breadcrumb-item
      >
      <b-breadcrumb-item active><h5>New Work Order</h5></b-breadcrumb-item>
    </b-breadcrumb> -->
    <vs-card style="border-radius: 20px;">
      <div class="mt-2" slot="header">
        <vs-row id="center">
          <h3 id="p" style="color: #003E9B">
            Work Template
          </h3>
          <h3 id="v" style="color: #003E9B">
            Work Template
          </h3>
          <vs-spacer
        /></vs-row>
      </div>

      <div class="mt-4 mb-1 ">
        <vs-row id="center">
          <h5>
            <b>Information</b>
          </h5>
        </vs-row>
      </div>

      <!-- type , status -->
      <vs-row vs-w="12">
        <vs-col
          class="mt-1 mb-2 a"
          vs-type="flex"
          vs-align="center"
          vs-lg="2"
          vs-sm="3"
          vs-xs="12"
        >
          <a>Type :</a>
        </vs-col>
        <vs-col
          class="mb-2  b"
          vs-type="flex"
          vs-align="center"
          vs-lg="4"
          vs-sm="3"
          vs-xs="12"
        >
          <vs-select
            class="selectExample"
            autocomplete
            v-model="select2"
            width="300px"
          >
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.text"
              v-for="(item, index) in options2"
            />
          </vs-select>
        </vs-col>
        <vs-col
          class="a mt-1 mb-2"
          vs-type="flex"
          vs-align="center"
          vs-lg="2"
          vs-sm="3"
          vs-xs="12"
        >
          <a>Status :</a>
        </vs-col>
        <vs-col
          class="b mb-2"
          vs-type="flex"
          vs-align="center"
          vs-lg="4"
          vs-sm="3"
          vs-xs="12"
        >
          <vs-select
            class="selectExample"
            autocomplete
            v-model="select2"
            width="300px"
          >
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.text"
              v-for="(item, index) in options2"
            />
          </vs-select>
        </vs-col>
      </vs-row>

      <!-- Title , Priority -->
      <vs-row vs-w="12">
        <vs-col
          class="mt-1 mb-2 a"
          vs-type="flex"
          vs-align="center"
          vs-lg="2"
          vs-sm="3"
          vs-xs="12"
        >
          <a>Title :</a>
        </vs-col>
        <vs-col
          class="mb-2 b "
          vs-type="flex"
          vs-align="center"
          vs-lg="4"
          vs-sm="3"
          vs-xs="12"
        >
          <vs-input class="ml-2 c" size="default" v-model="value2" />
        </vs-col>
        <vs-col
          class="a mt-1 mb-2"
          vs-type="flex"
          vs-align="center"
          vs-lg="2"
          vs-sm="3"
          vs-xs="12"
        >
          <a>Priority :</a>
        </vs-col>
        <vs-col
          class="b mb-2"
          vs-type="flex"
          vs-align="center"
          vs-lg="4"
          vs-sm="3"
          vs-xs="12"
        >
          <vs-select
            class="selectExample"
            autocomplete
            v-model="select2"
            width="300px"
          >
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.text"
              v-for="(item, index) in options2"
            />
          </vs-select>
        </vs-col>
      </vs-row>

      <!-- # , Trade -->
      <vs-row vs-w="12">
        <vs-col
          class="mt-1 mb-2 a"
          vs-type="flex"
          vs-align="center"
          vs-lg="2"
          vs-sm="3"
          vs-xs="12"
        >
          <a># :</a>
        </vs-col>
        <vs-col
          class="mb-2 b "
          vs-type="flex"
          vs-align="center"
          vs-lg="4"
          vs-sm="3"
          vs-xs="12"
        >
          <vs-input class="ml-2 c" size="default" v-model="value2" />
        </vs-col>
        <vs-col
          class="a mt-1 mb-2"
          vs-type="flex"
          vs-align="center"
          vs-lg="2"
          vs-sm="3"
          vs-xs="12"
        >
          <a>Trade :</a>
        </vs-col>
        <vs-col
          class="b mb-2"
          vs-type="flex"
          vs-align="center"
          vs-lg="4"
          vs-sm="3"
          vs-xs="12"
        >
          <vs-select
            class="selectExample"
            autocomplete
            v-model="select2"
            width="300px"
          >
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.text"
              v-for="(item, index) in options2"
            />
          </vs-select>
        </vs-col>
      </vs-row>

      <!-- Location , Spec Section -->
      <vs-row vs-w="12">
        <vs-col
          class="mt-1 mb-2 a"
          vs-type="flex"
          vs-align="center"
          vs-lg="2"
          vs-sm="3"
          vs-xs="12"
        >
          <a>Location :</a>
        </vs-col>
        <vs-col
          class="mb-2 b"
          vs-type="flex"
          vs-align="center"
          vs-lg="4"
          vs-sm="3"
          vs-xs="12"
        >
          <vs-select
            class="selectExample"
            autocomplete
            v-model="select2"
            width="300px"
          >
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.text"
              v-for="(item, index) in options2"
            />
          </vs-select>
        </vs-col>
        <vs-col
          class="a mt-1 mb-2"
          vs-type="flex"
          vs-align="center"
          vs-lg="2"
          vs-sm="3"
          vs-xs="12"
        >
          <a>Spec Section :</a>
        </vs-col>
        <vs-col
          class="b mb-2"
          vs-type="flex"
          vs-align="center"
          vs-lg="4"
          vs-sm="3"
          vs-xs="12"
        >
          <vs-select
            class="selectExample"
            autocomplete
            v-model="select2"
            width="300px"
          >
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.text"
              v-for="(item, index) in options2"
            />
          </vs-select>
        </vs-col>
      </vs-row>

      <!-- Assignee , Distribution -->
      <vs-row vs-w="12">
        <vs-col
          class="mt-1 mb-2 a"
          vs-type="flex"
          vs-align="center"
          vs-lg="2"
          vs-sm="3"
          vs-xs="12"
        >
          <a>Assignee :</a>
        </vs-col>
        <vs-col
          class="mb-2 b"
          vs-type="flex"
          vs-align="center"
          vs-lg="4"
          vs-sm="3"
          vs-xs="12"
        >
          <vs-select
            class="selectExample"
            autocomplete
            v-model="select2"
            width="300px"
          >
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.text"
              v-for="(item, index) in options2"
            />
          </vs-select>
        </vs-col>
        <vs-col
          class="a mt-1 mb-2"
          vs-type="flex"
          vs-align="center"
          vs-lg="2"
          vs-sm="3"
          vs-xs="12"
        >
          <a>Distribution :</a>
        </vs-col>
        <vs-col
          class="b mb-2"
          vs-type="flex"
          vs-align="center"
          vs-lg="4"
          vs-sm="3"
          vs-xs="12"
        >
          <vs-select
            class="selectExample"
            autocomplete
            v-model="select2"
            width="300px"
          >
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.text"
              v-for="(item, index) in options2"
            />
          </vs-select>
        </vs-col>
      </vs-row>

      <!-- Due Date , Hazard -->
      <vs-row vs-w="12">
        <vs-col
          class="mt-1 mb-2 a"
          vs-type="flex"
          vs-align="center"
          vs-lg="2"
          vs-sm="3"
          vs-xs="12"
        >
          <a>Due Date :</a>
        </vs-col>
        <vs-col
          class="mb-2 b"
          vs-type="flex"
          vs-align="center"
          vs-lg="4"
          vs-sm="3"
          vs-xs="12"
        >
         <div style="padding: 20px; padding-left: 20px;  ">
                                <datetime
                                  class="glyphicon glyphicon-cloud"
                                  
                                  type="datetime"
                                /><i></i>
                              </div>
        </vs-col>
        <vs-col
          class="a mt-1 mb-2"
          vs-type="flex"
          vs-align="center"
          vs-lg="2"
          vs-sm="3"
          vs-xs="12"
        >
          <a>Hazard :</a>
        </vs-col>
        <vs-col
          class="b mb-2"
          vs-type="flex"
          vs-align="center"
          vs-lg="4"
          vs-sm="3"
          vs-xs="12"
        >
          <vs-select
            class="selectExample"
            autocomplete
            v-model="select2"
            width="300px"
          >
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.text"
              v-for="(item, index) in options2"
            />
          </vs-select>
        </vs-col>
      </vs-row>

      <!-- Contributing Condition , Contributing Behavior -->
      <vs-row vs-w="12">
        <vs-col
          class="mt-1 mb-2 a"
          vs-type="flex"
          vs-align="center"
          vs-lg="2"
          vs-sm="3"
          vs-xs="12"
        >
          <a>Contributing Condition :</a>
        </vs-col>
        <vs-col
          class="mb-2 b"
          vs-type="flex"
          vs-align="center"
          vs-lg="4"
          vs-sm="3"
          vs-xs="12"
        >
          <vs-select
            class="selectExample"
            autocomplete
            v-model="select2"
            width="300px"
          >
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.text"
              v-for="(item, index) in options2"
            />
          </vs-select>
        </vs-col>
        <vs-col
          class="a mt-1 mb-2"
          vs-type="flex"
          vs-align="center"
          vs-lg="2"
          vs-sm="3"
          vs-xs="12"
        >
          <a>Contributing Behavior :</a>
        </vs-col>
        <vs-col
          class="b mb-2"
          vs-type="flex"
          vs-align="center"
          vs-lg="4"
          vs-sm="3"
          vs-xs="12"
        >
          <vs-select
            class="selectExample"
            autocomplete
            v-model="select2"
            width="300px"
          >
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.text"
              v-for="(item, index) in options2"
            />
          </vs-select>
        </vs-col>
      </vs-row>

     

      <!-- Description -->

      <vs-row class="mt-3" vs-w="12">
        <vs-col class="mt-2 " vs-lg="12" vs-sm="12" vs-xs="12">
          Description :
          {{content}}
        </vs-col>
      
      </vs-row>  

      
      <vs-row class="mt-3" vs-w="12">
        <vs-col class="mb-2 mt-1" vs-lg="12" vs-sm="12" vs-xs="12">
          <vue-editor id="editor1" v-model="content"></vue-editor>

        </vs-col>
      </vs-row>

       <vs-row class="mt-3 mb-3" vs-w="12">
        <vs-col class="mt-2 " vs-lg="12" vs-sm="12" vs-xs="12">
          <vs-button class="bts" color="success" type="filled">Send</vs-button>
          <vs-button class="ml-2" color="dark" to="/workorder" type="flat">Cancel</vs-button>
        </vs-col>
      </vs-row>  
    </vs-card>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
export default {
  name: "",
  components: {
    VueEditor,
  },
  data() {
    return {
      content: "",
      select1: 2,
      select2: 7,
      options1: [
        { text: "IT", value: 0 },
        { text: "Blade Runner", value: 2 },
        { text: "Thor Ragnarok", value: 3 },
      ],
      options2: [
        { text: "Square", value: 1 },
        { text: "Rectangle", value: 2 },
        { text: "Rombo", value: 3 },
        { text: "Romboid", value: 4 },
        { text: "Trapeze", value: 5 },
        { text: "Triangle", value: 6 },
        { text: "Select", value: 7 },
        { text: "Regular polygon", value: 8 },
        { text: "Circumference", value: 9 },
        { text: "Circle", value: 10 },
        { text: "Circular sector", value: 11 },
        { text: "Circular trapeze", value: 12 },
      ],
    };
  },
};
</script>

<style scoped>

input.vdatetime-input {
  border: none;
  padding-left: 10%;
  border-bottom: 1px solid black;
}
  
#editor1 {
  height: 350px;
  width: 900px;
}

.inputdes {
  width: 300px;
}
.c {
  width: 300px;
  border-radius: 100px;
}
.selectExample {
  margin: 10px;
}
.con-select-example {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
.con-select .vs-select {
  width: 100%;
}
@media (max-width: 550px) {
  .con-select {
    flex-direction: column;
  }
  .con-select .vs-select {
    width: 100%;
  }
}
.a {
  /* background-color: beige; */
}
.b {
  /* background-color: cadetblue; */
  padding-left: 0;
}
.d {
  background-color: grey;
}
button#dropdown-1_BV_toggle_.btn.dropdown-toggle.btn-secondary {
  border-radius: 5px;
}
th .sort-th .th-sort-icon {
  color: white;
  padding: 0px;
}
#v {
  display: none;
}
#center {
  display: flex;
  align-items: center;
}
#btncancel {
  background-color: #ffffff;
  border-radius: 0;
  border-color: #ffffff;
}
@media screen and (max-width: 600px) {
  #v {
    display: inline;
    padding: 0px;
    right: -20px;
  }
  #p {
    display: none;
  }
  .a {
    /* background: pink; */
    width: 200px;
  }
  .vuesax-app-is-ltr .vs-table--search-input {
    width: 100px;
    padding: o;
  }
  .vuesax-app-is-ltr .vs-table--search i {
    left: 15px;
  }
}
</style>
